export default __webpack_public_path__ + "static/saudia-ddab777a9e4c074294e726d9a645f634.svg";